import { Stack, Text, IconButton } from '@fluentui/react'
import { useAuth } from '../../auth/AuthProvider'

const UserMenu = () => {
  const { user, logout } = useAuth()

  const userName = user?.profile?.name || user?.profile?.email || 'User'

  return (
    <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 12 }}>
      <Text styles={{ root: { color: '#fff' } }}>{userName}</Text>
      <IconButton
        iconProps={{ iconName: 'SignOut' }}
        title="Sign Out"
        ariaLabel="Sign Out"
        onClick={() => logout()}
        styles={{
          root: { color: '#fff' },
          rootHovered: { color: '#fff', backgroundColor: 'rgba(255,255,255,0.2)' },
        }}
      />
    </Stack>
  )
}

export default UserMenu
